import { Group } from '@mantine/core';
import InputMention from 'pages/revisions-module/template-editor/editors/InputMention';
import { CHILD_DEPARTMENT_FIELD_LABELS } from 'pages/revisions-module/template-editor/editors/pipeline/configurator/properties/CreateChildDepartmentSubForm';
import { IAutomationCreateChildDepartment } from 'pages/revisions-module/template-editor/editors/pipeline/types';

/** Describes mapped child-object fields without executing the automation. */
export default function CreateChildDepartmentAutomationPreview({ data }: { data: IAutomationCreateChildDepartment }) {
  const parameters = Object.entries(CHILD_DEPARTMENT_FIELD_LABELS).flatMap(([field, label]) => {
    const name = data.fieldMappings?.[field as keyof IAutomationCreateChildDepartment['fieldMappings']];
    return name ? [{ field, label, name }] : [];
  });

  return (
    <Group spacing={8}>
      {parameters.map(({ field, label, name }, index) => (
        <Group key={field} spacing={8} noWrap>
          {index > 0 && <span>|</span>}
          <InputMention prefix={label} name={name} />
        </Group>
      ))}
    </Group>
  );
}
